import React from 'react';

import {Approve} from '@optimaxdev/icons';

import {QuestionMark} from 'desktop/components/helpers/icons/questionMark/questionMark';

import {AdvantagesType, PopupType, PropsType as AdvantagesPropsType} from './advantagesType';
import {POPUP} from './internal';

import s from './advantages.scss';

type PropsType = AdvantagesPropsType & {
    onClick: (popup: PopupType) => () => void;
};

/**
 * Return list with configured advantages
 * @param {PropsType} prop props of advantages
 * @returns {AdvantagesType} list of advantages
 */
export const getAdvantagesConfig = ({onClick}: PropsType): AdvantagesType => [
    {
        content: (
            <div className={s.buttonContainer}>
                Free shipping and returns
                <div className={s.questionMark}>
                    <QuestionMark color="green" />
                </div>
            </div>
        ),
        enabled: true,
        icon: Approve,
        iconSize: 'responsive',
        id: 'shipping',
        onClick: onClick(POPUP.SHIPPING),
    },
    {
        content: (
            <div className={s.buttonContainer}>
                100% money-back guarantee
                <div className={s.questionMark}>
                    <QuestionMark color="green" />
                </div>
            </div>
        ),
        enabled: true,
        icon: Approve,
        iconSize: 'responsive',
        id: 'moneyBack',
        onClick: onClick(POPUP.MONEY),
    },
];
